/**
 * Auto-generated file. Do not edit directly.
 */

export const assetFontLatoName = "Lato";
export const assetFontLatoWoffBlack = "Lato-Black.woff";
export const assetFontLatoWoff2Black = "Lato-Black.woff2";
export const assetFontLatoWoffBlackItalic = "Lato-BlackItalic.woff";
export const assetFontLatoWoff2BlackItalic = "Lato-BlackItalic.woff2";
export const assetFontLatoWoffBold = "Lato-Bold.woff";
export const assetFontLatoWoff2Bold = "Lato-Bold.woff2";
export const assetFontLatoWoffBoldItalic = "Lato-BoldItalic.woff";
export const assetFontLatoWoff2BoldItalic = "Lato-BoldItalic.woff2";
export const assetFontLatoWoffHairline = "Lato-Hairline.woff";
export const assetFontLatoWoff2Hairline = "Lato-Hairline.woff2";
export const assetFontLatoWoffHairlineItalic = "Lato-HairlineItalic.woff";
export const assetFontLatoWoff2HairlineItalic = "Lato-HairlineItalic.woff2";
export const assetFontLatoWoffHeavy = "Lato-Heavy.woff";
export const assetFontLatoWoff2Heavy = "Lato-Heavy.woff2";
export const assetFontLatoWoffHeavyItalic = "Lato-HeavyItalic.woff";
export const assetFontLatoWoff2HeavyItalic = "Lato-HeavyItalic.woff2";
export const assetFontLatoWoffItalic = "Lato-Italic.woff";
export const assetFontLatoWoff2Italic = "Lato-Italic.woff2";
export const assetFontLatoWoffLight = "Lato-Light.woff";
export const assetFontLatoWoff2Light = "Lato-Light.woff2";
export const assetFontLatoWoffLightItalic = "Lato-LightItalic.woff";
export const assetFontLatoWoff2LightItalic = "Lato-LightItalic.woff2";
export const assetFontLatoWoffMedium = "Lato-Medium.woff";
export const assetFontLatoWoff2Medium = "Lato-Medium.woff2";
export const assetFontLatoWoffMediumItalic = "Lato-MediumItalic.woff";
export const assetFontLatoWoff2MediumItalic = "Lato-MediumItalic.woff2";
export const assetFontLatoWoffRegular = "Lato-Regular.woff";
export const assetFontLatoWoff2Regular = "Lato-Regular.woff2";
export const assetFontLatoWoffSemibold = "Lato-Semibold.woff";
export const assetFontLatoWoff2Semibold = "Lato-Semibold.woff2";
export const assetFontLatoWoffSemiboldItalic = "Lato-SemiboldItalic.woff";
export const assetFontLatoWoff2SemiboldItalic = "Lato-SemiboldItalic.woff2";
export const assetFontLatoWoffThin = "Lato-Thin.woff";
export const assetFontLatoWoff2Thin = "Lato-Thin.woff2";
export const assetFontLatoWoffThinItalic = "Lato-ThinItalic.woff";
export const assetFontLatoWoff2ThinItalic = "Lato-ThinItalic.woff2";
export const assetFontAzeretMonoName = "Azeret Mono";
export const assetFontAzeretMonoWoff2Regular = "AzeretMono-Regular.woff2";
export const assetFontSs3vName = "Source Sans 3";
export const assetFontSs3vWoff = "SourceSans3VF-Upright.ttf.woff";
export const assetFontSs3vWoff2 = "SourceSans3VF-Upright.ttf.woff2";
export const colorBaseWhite = "#ffffff";
export const colorBaseBlack = "#000000";
export const colorBaseNeutral100 = "#f2f4f7";
export const colorBaseNeutral200 = "#ebecf0";
export const colorBaseNeutral300 = "#d7dbe0";
export const colorBaseNeutral400 = "#697687";
export const colorBaseNeutral500 = "#515c6c";
export const colorBaseNeutral600 = "#394251";
export const colorBaseNeutral700 = "#1b1f26";
export const colorBaseNeutralInverted400 = "#697687";
export const colorBaseBrand100 = "#c9e5e8";
export const colorBaseBrand200 = "#2db3c3";
export const colorBaseBrand300 = "#29a3b1";
export const colorBaseBrand400 = "#008194";
export const colorBaseBrand500 = "#017384";
export const colorBaseBrand600 = "#026371";
export const colorBaseBrand700 = "#175b63";
export const colorBaseBrandInverted400 = "#93b4f2";
export const colorBaseBrandInverted500 = "#93b4f2";
export const colorBaseBrandInverted600 = "#93b4f2";
export const colorBaseBlue100 = "#b3d5f8";
export const colorBaseBlue200 = "#80b9f3";
export const colorBaseBlue300 = "#2688ea";
export const colorBaseBlue400 = "#0073e6";
export const colorBaseBlue500 = "#006be3";
export const colorBaseBlue600 = "#0060df";
export const colorBaseBlue700 = "#0043d5";
export const colorBaseGreen100 = "#d4ede4";
export const colorBaseGreen200 = "#00bb7d";
export const colorBaseGreen300 = "#00aa71";
export const colorBaseGreen400 = "#008458";
export const colorBaseGreen500 = "#00754e";
export const colorBaseGreen600 = "#006946";
export const colorBaseGreen700 = "#005f40";
export const colorBaseOrange100 = "#ffdea8";
export const colorBaseOrange200 = "#ffd694";
export const colorBaseOrange300 = "#ffce80";
export const colorBaseOrange400 = "#ebb663";
export const colorBaseOrange500 = "#d6a75a";
export const colorBaseOrange600 = "#b0853e";
export const colorBaseOrange700 = "#9f6100";
export const colorBaseRed100 = "#fbc7bb";
export const colorBaseRed200 = "#f68368";
export const colorBaseRed300 = "#f46a49";
export const colorBaseRed400 = "#d9340d";
export const colorBaseRed500 = "#c22e0b";
export const colorBaseRed600 = "#ae2a0a";
export const colorBaseRed700 = "#9e2609";
export const colorThemePrimaryBg = "#008194";
export const colorThemePrimaryBgHover = "#017384";
export const colorThemePrimaryBgActive = "#026371";
export const colorThemePrimaryBgOutlined = "#ffffff";
export const colorThemePrimaryFill = "#ffffff";
export const colorThemePrimaryFillHover = "#ffffff";
export const colorThemePrimaryFillActive = "#ffffff";
export const colorThemePrimaryText = "#008194";
export const colorThemePrimaryTextHover = "#017384";
export const colorThemePrimaryTextActive = "#026371";
export const colorThemePrimaryInvertedBg = "#93b4f2";
export const colorThemePrimaryInvertedBgHover = "#93b4f2";
export const colorThemePrimaryInvertedBgActive = "#93b4f2";
export const colorThemePrimaryInvertedFill = "#000000";
export const colorThemePrimaryInvertedFillHover = "#000000";
export const colorThemePrimaryInvertedFillActive = "#000000";
export const colorThemePrimaryInvertedText = "#93b4f2";
export const colorThemePrimaryInvertedTextHover = "#93b4f2";
export const colorThemePrimaryInvertedTextActive = "#93b4f2";
export const colorThemeSecondaryBg = "#697687";
export const colorThemeSecondaryBgHover = "#697687";
export const colorThemeSecondaryBgActive = "#697687";
export const colorThemeSecondaryBgOutlined = "#ffffff";
export const colorThemeSecondaryFill = "#ffffff";
export const colorThemeSecondaryFillHover = "#ffffff";
export const colorThemeSecondaryFillActive = "#ffffff";
export const colorThemeSecondaryText = "#000000";
export const colorThemeSecondaryTextHover = "#000000";
export const colorThemeSecondaryTextActive = "#000000";
export const colorThemeSecondaryInvertedBg = "#697687";
export const colorThemeSecondaryInvertedBgHover = "#697687";
export const colorThemeSecondaryInvertedBgActive = "#697687";
export const colorThemeSecondaryInvertedFill = "#000000";
export const colorThemeSecondaryInvertedFillHover = "#000000";
export const colorThemeSecondaryInvertedFillActive = "#000000";
export const colorThemeSecondaryInvertedText = "#ffffff";
export const colorThemeSecondaryInvertedTextHover = "#ffffff";
export const colorThemeSecondaryInvertedTextActive = "#ffffff";
export const colorThemeInfoBg = "#0073e6";
export const colorThemeInfoBgHover = "#006be3";
export const colorThemeInfoBgActive = "#0060df";
export const colorThemeInfoBgOutlined = "#ffffff";
export const colorThemeInfoFill = "#ffffff";
export const colorThemeInfoFillHover = "#ffffff";
export const colorThemeInfoFillActive = "#ffffff";
export const colorThemeInfoText = "#0073e6";
export const colorThemeInfoTextHover = "#006be3";
export const colorThemeInfoTextActive = "#0060df";
export const colorThemeSuccessBg = "#008458";
export const colorThemeSuccessBgHover = "#00754e";
export const colorThemeSuccessBgActive = "#006946";
export const colorThemeSuccessBgOutlined = "#ffffff";
export const colorThemeSuccessFill = "#ffffff";
export const colorThemeSuccessFillHover = "#ffffff";
export const colorThemeSuccessFillActive = "#ffffff";
export const colorThemeSuccessText = "#008458";
export const colorThemeSuccessTextHover = "#00754e";
export const colorThemeSuccessTextActive = "#006946";
export const colorThemeWarningBg = "#ffce80";
export const colorThemeWarningBgHover = "#ffd694";
export const colorThemeWarningBgActive = "#ffdea8";
export const colorThemeWarningBgOutlined = "#ffffff";
export const colorThemeWarningFill = "#000000";
export const colorThemeWarningFillHover = "#000000";
export const colorThemeWarningFillActive = "#000000";
export const colorThemeWarningText = "#9f6100";
export const colorThemeWarningTextHover = "#9f6100";
export const colorThemeWarningTextActive = "#9f6100";
export const colorThemeDangerBg = "#d9340d";
export const colorThemeDangerBgHover = "#c22e0b";
export const colorThemeDangerBgActive = "#ae2a0a";
export const colorThemeDangerBgOutlined = "#ffffff";
export const colorThemeDangerFill = "#ffffff";
export const colorThemeDangerFillHover = "#ffffff";
export const colorThemeDangerFillActive = "#ffffff";
export const colorThemeDangerText = "#d9340d";
export const colorThemeDangerTextHover = "#c22e0b";
export const colorThemeDangerTextActive = "#ae2a0a";
export const colorUiBackgroundCanvas = "#f2f4f7";
export const colorUiBackgroundSurface = "#ffffff";
export const colorUiBackgroundSurfaceInverted = "#1b1f26";
export const colorUiBackgroundMuted = "#f2f4f7";
export const colorUiBackgroundInput = "#ffffff";
export const colorUiBackgroundInputAutofill = "#e8f0fe";
export const colorUiBackgroundSkeleton = "#ebecf0";
export const colorUiBackgroundSkeletonHighlight = "#d7dbe0";
export const colorUiBackgroundTooltip = "#000000";
export const colorUiBackgroundBackdrop = "#1b1f26";
export const colorUiBorderLight = "#f2f4f7";
export const colorUiBorderDefault = "#ebecf0";
export const colorUiBorderDark = "#d7dbe0";
export const colorUiBorderFocus = "#0071ff";
export const colorUiBorderQuote = "#697687";
export const colorUiBorderCard = "#00000000";
export const colorUiFontBase = "#000000";
export const colorUiFontBaseInverted = "#ffffff";
export const colorUiFontMuted = "#515c6c";
export const colorUiFontQuote = "#515c6c";
export const colorUiFontTooltip = "#ffffff";
export const fontFamilyBase = "Lato";
export const fontFamilyMono = "''";
export const fontFamilyEmoji = "''";
export const fontWeightHead = 600;
export const fontWeightBody = 400;
export const fontWeightMono = 400;
export const fontDecorationLink = "none";
export const fontDecorationLinkHover = "underline";
export const fontDecorationLinkButton = "none";
export const fontDecorationLinkButtonHover = "underline";
export const opacityDisabled = 0.65;
export const opacityBackdrop = 0.4;
export const opacityTooltip = 1;
export const sizeBorderRadiusL = 0.5;
export const sizeBorderRadiusM = 0.25;
export const sizeBorderRadiusS = 0.125;
export const sizeFontHead1 = 1.75;
export const sizeFontHead2 = 1.5;
export const sizeFontHead3 = 1.25;
export const sizeFontHead4 = 1.125;
export const sizeFontHead5 = 0.9375;
export const sizeFontHead6 = 0.875;
export const sizeFontBodyXl = 1.25;
export const sizeFontBodyL = 1.125;
export const sizeFontBodyM = 0.9375;
export const sizeFontBodyS = 0.875;
export const sizeFontBodyXs = 0.75;
export const sizeFontMonoXl = 1.125;
export const sizeFontMonoL = 0.9375;
export const sizeFontMonoM = 0.875;
export const sizeFontMonoS = 0.75;
export const sizeFontMonoXs = 0.625;
export const sizeLineHead1 = 2;
export const sizeLineHead2 = 1.75;
export const sizeLineHead3 = 1.5;
export const sizeLineHead4 = 1.5;
export const sizeLineHead5 = 1.25;
export const sizeLineHead6 = 1;
export const sizeLineBodyXl = 1.5;
export const sizeLineBodyL = 1.5;
export const sizeLineBodyM = 1.25;
export const sizeLineBodyS = 1.125;
export const sizeLineBodyXs = 1;
export const sizeLineMonoXl = 1.5;
export const sizeLineMonoL = 1.25;
export const sizeLineMonoM = 1.125;
export const sizeLineMonoS = 1;
export const sizeLineMonoXs = 0.875;
export const sizeModalS = 400;
export const sizeModalM = 600;
export const sizeModalL = 800;
export const sizeScreenXs = 540;
export const sizeScreenS = 768;
export const sizeScreenM = 992;
export const sizeScreenL = 1200;
export const sizeScreenXl = 1400;
export const sizeSpacingXl = 2;
export const sizeSpacingL = 1.5;
export const sizeSpacingM = 1;
export const sizeSpacingS = 0.5;
export const sizeSpacingXs = 0.25;
export const timeTransitionL = 500;
export const timeTransitionM = 250;
export const timeTransitionS = 125;
export const timeDelayL = 500;
export const timeDelayM = 250;
export const timeDelayS = 125;
export const timeDurationL = 1000;
export const timeDurationM = 500;
export const timeDurationS = 250;
export const zIndexBase = 1000;
export const zIndexDropdown = 100;
export const zIndexTooltip = 200;
